export default __webpack_public_path__ + "static/media/slider3.53f2c885.png";